var _ellipse, _path, _path2, _path3, _rect, _path4, _path5, _circle, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _g, _path27, _path28, _path29, _path30, _path31, _path32, _g2, _path33, _path34, _circle2, _path35, _path36, _circle3, _path37, _path38, _path39, _path40, _path41;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgEarth = function SvgEarth(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 464 846",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(1)"
  }, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 267.51,
    cy: 829.05,
    fill: "#e6e7e8",
    fillRule: "nonzero",
    rx: 195.11,
    ry: 16.79
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M368.79 834.47c-13.24-7.94-23.83-10.84-27.85-11.73l-29.32-267.39-66-8-1.55 7.17a33.41 33.41 0 0 0-.7 8.58l12.43 259.51c-3 .6-14.32 3.25-28.78 11.92h45.07l-.65-12.3 2.18-233.88h6L324 823.47l-.25 11z",
    fill: "#12186d",
    fillRule: "nonzero",
    stroke: "#12186d",
    strokeWidth: 1.56
  })), /*#__PURE__*/React.createElement("path", {
    d: "m151.62 301.35 12.32 7.29a46.47 46.47 0 0 0 8.72 3.54l19.46 5.67 8.5 9.5 9-2-3.5-14.5z",
    style: {
      stroke: "#12186d",
      strokeWidth: 2,
      fill: "#fff",
      fillRule: "nonzero",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.3 454.18a30.11 30.11 0 0 1-8.55 4.26 32.67 32.67 0 0 1-12.69 1.24 36.62 36.62 0 0 1-13.86-3.87c-1.72-.89-4.91-3.37-11.23-8.29-2-1.54-2.16-1.69-8.4-6.61l-11.7-9.21-6.64-5.23-7.43-5.86c-6.91-5.41-7.62-5.91-8.92-7.5a26.06 26.06 0 0 1-4.28-7.49c-1.48-4-1.44-7.21-1.52-10.65-.14-5.52-1-11-1.27-16.51-.28-6.49-5.67-42.26-7.19-57.11 2-2 4-5 17-7 .58 3.95 9.83 43.37 10.41 47.31 1.42 9.67 4.17 24 5.59 33.69 6.42 4.48 36 15 46.78 17.06l1.22-.06",
    style: {
      stroke: "#12186d",
      strokeWidth: 2,
      fill: "#55f99f",
      fillRule: "nonzero",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M267.92 586.42v1.93h11.92l-.04-1.77z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M353.58 453.87c.82-13.11-9.91-21.22-11.86-22.86l-1.59-1.33-24.47-17.32-32.15-2-9.21 2.43a37 37 0 0 0-17 9.63c-5.72 5.79-6 10.4-7.72 19.93-.75 4.09-4 105.06-4 105.06l66.09 7.94s41.64-97.35 41.91-101.48z",
    style: {
      stroke: "#12186d",
      strokeWidth: 2,
      fill: "#55f99f",
      fillRule: "nonzero",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m316.76 393-1.64 17.35s-17.61 11.81-26.46 10.65-6.82-5.62-6.82-5.62l2.61-21.72s27.55-15.93 32.31-.66z",
    style: {
      stroke: "#12186d",
      strokeWidth: 2,
      fill: "#fff",
      fillRule: "nonzero",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M284.91 393.35c-.06.59-.1 1.17-.11 1.73-.11 7.58 4.39 11.72 16.67 12.59a26.53 26.53 0 0 0 14.17-2.75l1.12-11.92c-4.4-14.12-28.27-1.62-31.85.35z",
    fill: "#12186d",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 285.45,
    cy: 373.33,
    r: 5.66,
    style: {
      stroke: "#12186d",
      strokeWidth: 2,
      fill: "#fff",
      fillRule: "nonzero",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 322.77,
    cy: 379.17,
    r: 5.66,
    style: {
      stroke: "#12186d",
      strokeWidth: 2,
      fill: "#fff",
      fillRule: "nonzero",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#12186d",
    fillRule: "nonzero",
    height: 11.88,
    rx: 5.94,
    stroke: "#12186d",
    strokeWidth: 0.5,
    transform: "rotate(6.86 289.32 352.637)",
    width: 11.88,
    x: 283.38,
    y: 346.697
  })), /*#__PURE__*/React.createElement("path", {
    d: "m323.92 355.48-4.27 35.46c-.71 5.91-9.73 12.82-22 11.95s-16.79-5-16.67-12.6 5.27-19 5.83-26.89 1.07-11.81 3.63-16.9 29.96 1.66 33.48 8.98z",
    style: {
      stroke: "#12186d",
      strokeWidth: 2,
      fill: "#fff",
      fillRule: "nonzero",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M323.44 373.56s4-10.91 5.71-16.26-2.24-8.81-7-9.08-6.95 1.71-6.95 1.71l1 2.82s7.1 2.05 6.94 7.13a142.7 142.7 0 0 1-1.73 14.3z",
    fill: "#12186d",
    fillRule: "nonzero",
    stroke: "#12186d",
    strokeWidth: 0.3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m298.4 366.17-4.24 13.11 5.99.72",
    stroke: "#12186d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("path", {
    d: "M291.56 386c0 .13 0 .27-.05.4a5.92 5.92 0 0 0 11.8.9v-.27z",
    style: {
      stroke: "#12186d",
      strokeWidth: 2,
      fill: "#fff",
      fillRule: "nonzero",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 308.36,
    cy: 368.51,
    fill: "#12186d",
    fillRule: "nonzero",
    r: 1.6
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M291.38 365a1.44 1.44 0 1 0-.23 2.87 1.44 1.44 0 0 0 .23-2.87zM317.89 362.58c-1.71-2.74-5.14-3.92-8.23-3.72-1.94.12-2 3.16 0 3a6.64 6.64 0 0 1 4.52 1.13c.332.251.637.536.91.85.24.27 0-.1.18.24 1 1.66 3.66.13 2.62-1.53zM290.25 360.21c-.56.44 0 0 .16-.08a7.29 7.29 0 0 1 1.11-.48 6.45 6.45 0 0 1 4.41.34c1.77.76 3.32-1.85 1.53-2.61-3.07-1.31-6.63-1.46-9.36.68-1.53 1.21.63 3.34 2.15 2.15z",
    fill: "#12186d",
    fillRule: "nonzero"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M316.75 352.66s-8.18 2.78-16.49.76-15.05-7.81-14.75-18.78l3 .76a12.31 12.31 0 0 1 .25-6.28s8.76 3.39 12.75 4.08a42.13 42.13 0 0 0-3.69-3.2s17 .93 21.26 9.59-2.33 13.07-2.33 13.07z",
    fill: "#12186d",
    fillRule: "nonzero",
    stroke: "#12186d",
    strokeWidth: 0.3
  })), /*#__PURE__*/React.createElement("path", {
    d: "m210.62 314.35-3.99-1.38",
    style: {
      stroke: "#12186d",
      strokeWidth: 2.02,
      fill: "#55f99f",
      fillRule: "nonzero",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.5 563.86c-.23 7-1.66 12.32-1.95 15.55a16.32 16.32 0 0 0 3.65 11.81l9.26 11.26a5.09 5.09 0 0 0 .94-5.37l-4.61-8 11.18 8-1.3 2.42a3.31 3.31 0 0 0 .7 4l2.16-2.39-2.16 2.39-.44.48a3.21 3.21 0 0 0 .22 4.55l3-3.34-1.56 2.1a4.28 4.28 0 0 0 .57 5.71l8.24-9.08-.06-6.92a9.09 9.09 0 0 0-3.51-7.08c-4.93-3.81-13.46-11.07-14.35-16.2-.23-1.34 0-4.33.55-8.37",
    style: {
      stroke: "#12186d",
      strokeWidth: 2,
      fill: "#fff",
      fillRule: "nonzero",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m319.12 465.88 66.5 120.47 18-10C393 548.61 353.1 445.46 350.55 441.43c-3.72-5.92-14.68-14.52-14.68-14.52",
    style: {
      stroke: "#12186d",
      strokeWidth: 2,
      fill: "#55f99f",
      fillRule: "nonzero",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.38 124.44h7.63v2.1h-7.63z",
    style: {
      stroke: "#12186d",
      strokeWidth: 1.33,
      fill: "#12186d",
      fillRule: "nonzero",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.67 124.44h19.71v2.1H21.67z",
    style: {
      stroke: "#12186d",
      strokeWidth: 1.33,
      fill: "#fff",
      fillRule: "nonzero",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.88 116.48h2.82v7.88h-2.82z",
    style: {
      stroke: "#12186d",
      strokeWidth: 1.33,
      fill: "#12186d",
      fillRule: "nonzero",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.6 116.48h7.28v7.88H29.6z",
    style: {
      stroke: "#12186d",
      strokeWidth: 1.33,
      fill: "#fff",
      fillRule: "nonzero",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.95 118.33H.67l24.06-23.45h52.29z",
    style: {
      stroke: "#12186d",
      strokeWidth: 1.33,
      fill: "#fff",
      fillRule: "nonzero",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M52.95 118.33H.67l24.06-23.45h52.29z",
    fill: "#fff",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      fill: "#fff",
      fillRule: "nonzero",
      stroke: "#12186d",
      strokeWidth: 1.33
    }
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m52.2 93.58-27.18 26.49M18.57 99.65h56.72M13.74 104.37h56.71M8.9 109.09h56.71M4.06 113.8h56.71"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M52.95 118.33H.67l24.06-23.45h52.29z",
    stroke: "#12186d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.33
  })), /*#__PURE__*/React.createElement("path", {
    d: "M.66 118.33h52.38v.81H.66z",
    style: {
      stroke: "#12186d",
      strokeWidth: 1.33,
      fill: "#fff",
      fillRule: "nonzero",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.02 94.88v.9l-23.98 23.37v-.82z",
    style: {
      stroke: "#12186d",
      strokeWidth: 1.33,
      fill: "#12186d",
      fillRule: "nonzero",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M77.02 95.92H24.73L.67 119.38v.81h52.37l23.98-23.37z",
    fill: "#55f99f",
    fillRule: "nonzero"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M112.77 127s2 6.63 14.47 5.89L120 127z",
    stroke: "#12186d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.21
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M120.14 127.41s1.94 6.63 14.46 5.89l-7.23-5.89z",
    fill: "#55f99f",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M104.35 124.85h6.13v1.68h-6.13z",
    style: {
      stroke: "#12186d",
      strokeWidth: 1.33,
      fill: "#12186d",
      fillRule: "nonzero",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.53 124.85h15.82v1.68H88.53z",
    style: {
      stroke: "#12186d",
      strokeWidth: 1.33,
      fill: "#fff",
      fillRule: "nonzero",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.74 118.47H103v6.32h-2.26z",
    style: {
      stroke: "#12186d",
      strokeWidth: 1.33,
      fill: "#12186d",
      fillRule: "nonzero",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.9 118.47h5.84v6.32H94.9z",
    style: {
      stroke: "#12186d",
      strokeWidth: 1.33,
      fill: "#fff",
      fillRule: "nonzero",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.64 119.95H71.67l19.32-18.83h41.97z",
    style: {
      stroke: "#12186d",
      strokeWidth: 1.33,
      fill: "#fff",
      fillRule: "nonzero",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M113.64 119.95H71.67l19.32-18.83h41.97z",
    fill: "#fff",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      fill: "#fff",
      fillRule: "nonzero",
      stroke: "#12186d",
      strokeWidth: 1.33
    }
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m113.04 100.08-21.82 21.27M86.05 104.96h45.52M82.16 108.74h45.53M78.28 112.53h45.52M74.4 116.31h45.52"
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M113.64 119.95H71.67l19.32-18.83h41.97z",
    stroke: "#12186d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.33
  })), /*#__PURE__*/React.createElement("path", {
    d: "M71.67 119.95h42.05v.65H71.67z",
    style: {
      stroke: "#12186d",
      strokeWidth: 1.33,
      fill: "#fff",
      fillRule: "nonzero",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.96 101.12v.73l-19.24 18.75v-.65z",
    style: {
      stroke: "#12186d",
      strokeWidth: 1.33,
      fill: "#12186d",
      fillRule: "nonzero",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M132.96 101.96H90.99l-19.32 18.83v.65h42.05l19.24-18.76z",
    fill: "#55f99f",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M73.77 124.62h6.99v1.92h-6.99z",
    style: {
      stroke: "#12186d",
      strokeWidth: 1.33,
      fill: "#12186d",
      fillRule: "nonzero",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.73 124.62h18.04v1.92H55.73z",
    style: {
      stroke: "#12186d",
      strokeWidth: 1.33,
      fill: "#fff",
      fillRule: "nonzero",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.65 117.33h2.58v7.21h-2.58z",
    style: {
      stroke: "#12186d",
      strokeWidth: 1.33,
      fill: "#12186d",
      fillRule: "nonzero",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.99 117.33h6.66v7.21h-6.66z",
    style: {
      stroke: "#12186d",
      strokeWidth: 1.33,
      fill: "#fff",
      fillRule: "nonzero",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.36 119.03H36.5l22.03-21.47h47.86z",
    style: {
      stroke: "#12186d",
      strokeWidth: 1.33,
      fill: "#fff",
      fillRule: "nonzero",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M84.36 119.03H36.5l22.03-21.47h47.86z",
    fill: "#fff",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      fill: "#fff",
      fillRule: "nonzero",
      stroke: "#12186d",
      strokeWidth: 1.33
    }
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M83.68 96.37 58.8 120.62M52.89 101.93h51.92M48.46 106.24h51.92M44.03 110.56h51.92M39.61 114.88h51.91"
  }))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M84.36 119.03H36.5l22.03-21.47h47.86z",
    stroke: "#12186d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.33
  })), /*#__PURE__*/React.createElement("path", {
    d: "M36.5 119.03h47.95v.74H36.5z",
    style: {
      stroke: "#12186d",
      strokeWidth: 1.33,
      fill: "#fff",
      fillRule: "nonzero",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.39 97.56v.82l-21.95 21.39v-.74z",
    style: {
      stroke: "#12186d",
      strokeWidth: 1.33,
      fill: "#12186d",
      fillRule: "nonzero",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M106.39 98.51H58.53L36.5 119.98v.75h47.94l21.95-21.39z",
    fill: "#55f99f",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m115.96 39.28-4.61-.21-.03 9.36h4.9zM116.41 54.88h-5.1l-.02 5.64h5.28zM111.14 116.41l7.03-.11-1.07-37.24h-5.86zM116.75 66.97h-5.48l-.01 5.63h5.66z",
    style: {
      stroke: "#12186d",
      strokeWidth: 1.33,
      fill: "#fff",
      fillRule: "nonzero",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "m111.26 72.6-.02 6.46h5.86l-.18-6.46zM116.57 60.52h-5.28l-.02 6.45h5.48zM116.22 48.43h-4.9l-.01 6.45h5.1z",
    fill: "#12186d",
    fillRule: "nonzero",
    stroke: "#12186d",
    strokeWidth: 1.33
  })), /*#__PURE__*/React.createElement("path", {
    d: "M109.66 116.2h10v9.9h-10zM113.24 39.13l.67 7.25-19.05 30.28-1.91-.1 18.99-38.57zM112.68 36.84l-6.63-3.01L89.19 2.28 90.23.67l24.08 35.61z",
    style: {
      stroke: "#12186d",
      strokeWidth: 1.33,
      fill: "#fff",
      fillRule: "nonzero",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "m112.62 38.52.68 7.25-19.05 30.28-1.92-.11 19-38.56zM113.5 36.56l-6.63-3L90.01 2 91.05.39 115.13 36z",
    fill: "#55f99f",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m114.89 36.39 5.97-4.16 35.74 1.64.86 1.71-42.92 2.5z",
    style: {
      stroke: "#12186d",
      strokeWidth: 1.33,
      fill: "#fff",
      fillRule: "nonzero",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "m114.75 35.85 5.98-4.16 35.74 1.63.85 1.72-42.92 2.49z",
    fill: "#55f99f",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 113.7,
    cy: 37.27,
    r: 3.11,
    style: {
      stroke: "#12186d",
      strokeWidth: 1.33,
      fill: "#fff",
      fillRule: "nonzero",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M127.33 10.57a29.38 29.38 0 0 1 16.24 21.16M85.47 35.16c0-.4.06-.8.1-1.2M86.78 45.93a29 29 0 0 1-1.36-7.85M95.39 59.1a29.58 29.58 0 0 1-7.53-10.29M125.8 64.21a29.37 29.37 0 0 1-28.57-3.62",
    stroke: "#12186d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.66
  })), /*#__PURE__*/React.createElement("path", {
    d: "M145.87 48.05h3.42v.32a1.71 1.71 0 1 1-3.42 0z",
    style: {
      stroke: "#12186d",
      strokeWidth: 2,
      fill: "#fff",
      fillRule: "nonzero",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    transform: "rotate(180 147.58 49.065)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.17 49.67h26.86v2.52c0 7.428-6.022 13.45-13.45 13.45-7.413-.022-13.41-6.037-13.41-13.45z",
    style: {
      stroke: "#12186d",
      strokeWidth: 2,
      fill: "#fff",
      fillRule: "nonzero",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    transform: "rotate(180 147.6 57.655)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.04 63.05h29.09v56.87h-29.09z",
    style: {
      stroke: "#12186d",
      strokeWidth: 2,
      fill: "#fff",
      fillRule: "nonzero",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    transform: "rotate(180 147.585 91.485)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.92 119.08h31.32v7.13h-31.32z",
    style: {
      stroke: "#12186d",
      strokeWidth: 2,
      fill: "#fff",
      fillRule: "nonzero",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    transform: "rotate(180 147.58 122.645)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.42 48.05h3.42v.32a1.71 1.71 0 1 1-3.42 0z",
    style: {
      stroke: "#12186d",
      strokeWidth: 2,
      fill: "#fff",
      fillRule: "nonzero",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    transform: "rotate(180 170.13 49.065)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.68 49.67h26.9v2.52c0 7.428-6.022 13.45-13.45 13.45s-13.45-6.022-13.45-13.45z",
    style: {
      stroke: "#12186d",
      strokeWidth: 2,
      fill: "#fff",
      fillRule: "nonzero",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    transform: "rotate(180 170.13 57.655)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.58 63.05h29.09v56.87h-29.09z",
    style: {
      stroke: "#12186d",
      strokeWidth: 2,
      fill: "#fff",
      fillRule: "nonzero",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    transform: "rotate(180 170.125 91.485)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.47 119.08h31.32v7.13h-31.32z",
    style: {
      stroke: "#12186d",
      strokeWidth: 2,
      fill: "#fff",
      fillRule: "nonzero",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    transform: "rotate(180 170.13 122.645)"
  }), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "m142.28 106.44-2.45-3.19M143.13 105.73l-1.24-3.83M141.46 105.88l1.33-3.81M167.87 105.34l-1.23-3.84M166.2 105.48l1.33-3.8M143.78 106.44l-3.77-1.41M142.79 110.32l-2.39 3.25M145.17 116.94l-2.38 3.25M145.51 118.14l-2.38 3.24",
    stroke: "#12186d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.33
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M143.51 114.42h19.11v11.78h-19.11z",
    fill: "#fff",
    stroke: "#12186d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.33
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.62 114.42h8.42v11.78h-8.42z",
    fill: "#12186d",
    stroke: "#12186d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.33
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.76 114.42h1.67v11.78h-1.67zM154.69 114.42h1.67v11.78h-1.67z",
    fill: "#12186d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.92 102.64h19.11v11.78h-19.11z",
    fill: "#fff",
    stroke: "#12186d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.33
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.04 102.64h8.42v11.78h-8.42z",
    fill: "#12186d",
    stroke: "#12186d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.33
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.17 102.64h1.67v11.78h-1.67zM152.11 102.64h1.67v11.78h-1.67z",
    fill: "#12186d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.96 106.28h-.45l1.69 3.34v16.37h.46v-16.34z",
    fill: "#12186d",
    stroke: "#12186d",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m64.51 106.28-1.69 3.37v16.34h3.38v-16.34zM66.2 115.36h7.66v2.6H66.2z",
    fill: "#fff",
    stroke: "#12186d",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.12 106.28h-.46l1.69 3.34v16.37h.46v-16.34z",
    fill: "#12186d",
    stroke: "#12186d",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m73.66 106.28-1.69 3.37v16.34h3.38v-16.34zM75.35 115.36h7.66v2.6h-7.66z",
    fill: "#fff",
    stroke: "#12186d",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.27 106.28h-.45l1.69 3.34v16.37h.45v-16.34z",
    fill: "#12186d",
    stroke: "#12186d",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m82.82 106.28-1.7 3.37v16.34h3.39v-16.34zM84.51 115.36h7.66v2.6h-7.66z",
    fill: "#fff",
    stroke: "#12186d",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.43 106.28h-.46l1.69 3.34v16.37h.46v-16.34z",
    fill: "#12186d",
    stroke: "#12186d",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m91.97 106.28-1.69 3.37v16.34h3.38v-16.34zM93.66 115.36h7.66v2.6h-7.66z",
    fill: "#fff",
    stroke: "#12186d",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.58 106.28h-.45l1.69 3.34v16.37h.45v-16.34z",
    fill: "#12186d",
    stroke: "#12186d",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m101.13 106.28-1.7 3.37v16.34h3.39v-16.34zM102.82 115.36h7.66v2.6h-7.66z",
    fill: "#fff",
    stroke: "#12186d",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.73 106.28h-.45l1.69 3.34v16.37h.46v-16.34z",
    fill: "#12186d",
    stroke: "#12186d",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m110.28 106.28-1.69 3.37v16.34h3.38v-16.34zM111.97 115.36h7.66v2.6h-7.66z",
    fill: "#fff",
    stroke: "#12186d",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.89 106.28h-.46l1.7 3.34v16.37h.45v-16.34z",
    fill: "#12186d",
    stroke: "#12186d",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m119.43 106.28-1.69 3.37v16.34h3.39v-16.34z",
    fill: "#fff",
    stroke: "#12186d",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.13 115.36h7.66v2.6h-7.66z",
    fill: "#fff",
    stroke: "#12186d",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.04 106.28h-.45l1.69 3.34v16.37h.46v-16.34z",
    fill: "#12186d",
    stroke: "#12186d",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m128.59 106.28-1.69 3.37v16.34h3.38v-16.34zM130.28 115.36h7.66v2.6h-7.66z",
    fill: "#fff",
    stroke: "#12186d",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.2 106.28h-.46l1.69 3.34v16.37h.46v-16.34z",
    fill: "#12186d",
    stroke: "#12186d",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m137.74 106.28-1.69 3.37v16.34h3.38v-16.34zM139.43 115.36h7.66v2.6h-7.66z",
    fill: "#fff",
    stroke: "#12186d",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.35 106.28h-.45l1.69 3.34v16.37h.45v-16.34z",
    fill: "#12186d",
    stroke: "#12186d",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m146.9 106.28-1.7 3.37v16.34h3.39v-16.34zM148.59 115.36h7.66v2.6h-7.66z",
    fill: "#fff",
    stroke: "#12186d",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.51 106.28h-.46l1.69 3.34v16.37h.46v-16.34z",
    fill: "#12186d",
    stroke: "#12186d",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m156.05 106.28-1.69 3.37v16.34h3.38v-16.34zM157.74 115.36h7.66v2.6h-7.66z",
    fill: "#fff",
    stroke: "#12186d",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.66 106.28h-.45l1.69 3.34v16.37h.45v-16.34z",
    fill: "#12186d",
    stroke: "#12186d",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m165.21 106.28-1.7 3.37v16.34h3.39v-16.34zM166.9 115.36h7.66v2.6h-7.66z",
    fill: "#fff",
    stroke: "#12186d",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.81 106.28h-.45l1.69 3.34v16.37h.46v-16.34z",
    fill: "#12186d",
    stroke: "#12186d",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m174.36 106.28-1.69 3.37v16.34h3.38v-16.34z",
    fill: "#fff",
    stroke: "#12186d",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.38 89.82a7.42 7.42 0 0 1-6.2-.93 7.29 7.29 0 0 1-2.88-4.59 5.26 5.26 0 0 1-2.07-9.58 7.25 7.25 0 0 1-.8-7.79 6.53 6.53 0 0 1 3.19-2.74 7 7 0 0 1 .87-6 6 6 0 0 1 2.31-1.81c-.78-2.68.24-5.15 1.93-5.86a3.75 3.75 0 0 1 2.88.19 2.39 2.39 0 0 1 2.64-1.35A2.37 2.37 0 0 1 222 51.3a4.22 4.22 0 0 1 3.33 1.92c.44.78.588 1.69.42 2.57a5.48 5.48 0 0 1 3.8 4.21 5 5 0 0 1-.52 3 5.37 5.37 0 0 1 2.9 3.24A5.47 5.47 0 0 1 231 71a6.25 6.25 0 0 1 2.67 6.14 6.16 6.16 0 0 1-2.6 3.86 4.46 4.46 0 0 1-4.95 6.72 5.86 5.86 0 0 1-4.18 2.9 5.53 5.53 0 0 1-3.56-.8z",
    fill: "#fff",
    stroke: "#12186d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.33
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.92 68.12a1.83 1.83 0 0 1 .83 2.24 1.78 1.78 0 0 1-1.56 1 2.13 2.13 0 0 1-2 3.36M220.57 116.38h-2.09V82.7h2.09z",
    fill: "#fff",
    stroke: "#12186d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.33
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.93 82.08a1.83 1.83 0 0 1-1.83 1.54 1.78 1.78 0 0 1-1.48-1.12 2.14 2.14 0 0 1-2 .9 2.17 2.17 0 0 1-1.8-1.62",
    fill: "#fff",
    stroke: "#12186d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.33
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.59 89.82a7.39 7.39 0 0 1-6.19-.93 7.19 7.19 0 0 1-2.88-4.59 5.26 5.26 0 0 1-2.07-9.58 7.25 7.25 0 0 1-.81-7.79 6.58 6.58 0 0 1 3.2-2.74 7 7 0 0 1 .87-6A6 6 0 0 1 215 56.4c-.78-2.68.24-5.15 1.93-5.86a3.75 3.75 0 0 1 2.88.19 2.32 2.32 0 0 1 4.43.57 4.21 4.21 0 0 1 3.32 1.92 3.88 3.88 0 0 1 .43 2.57 5.48 5.48 0 0 1 3.78 4.21 5 5 0 0 1-.52 3 5.4 5.4 0 0 1 2.9 3.24 5.5 5.5 0 0 1-.93 4.78 6.27 6.27 0 0 1 2.67 6.14 6.2 6.2 0 0 1-2.6 3.86 4.46 4.46 0 0 1-4.95 6.72 5.88 5.88 0 0 1-4.18 2.9 5.58 5.58 0 0 1-3.57-.82z",
    fill: "#55f99f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.82 62.5a.91.91 0 0 0-1.36-.79c.056-.14.086-.29.09-.44a1.09 1.09 0 0 0-1.09-1.08 1.06 1.06 0 0 0-.67.24 1.42 1.42 0 0 0-2.81.15 1.42 1.42 0 0 0 0 2.84h5a.9.9 0 0 0 .84-.92z",
    fill: "#fff",
    stroke: "#12186d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.33
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.82 92a7.39 7.39 0 0 0 6.18-1 7.15 7.15 0 0 0 2.88-4.59 5.26 5.26 0 0 0 2.12-9.56 7.23 7.23 0 0 0 .8-7.79 6.49 6.49 0 0 0-3.19-2.73 7 7 0 0 0-.87-6 6.12 6.12 0 0 0-2.31-1.81c.78-2.68-.24-5.14-1.93-5.85a3.75 3.75 0 0 0-2.88.18 2.32 2.32 0 0 0-4.43.57 4.24 4.24 0 0 0-3.33 1.92 3.87 3.87 0 0 0-.42 2.58 5.47 5.47 0 0 0-3.76 4.16 5 5 0 0 0 .52 3 5.37 5.37 0 0 0-2.9 3.23 5.47 5.47 0 0 0 .93 4.78 5.93 5.93 0 0 0-.07 10 4.46 4.46 0 0 0 4.95 6.72 5.88 5.88 0 0 0 4.18 2.9 5.58 5.58 0 0 0 3.53-.71z",
    fill: "#fff",
    stroke: "#12186d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.33
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232 64.22a1.84 1.84 0 0 0-2.35-.44 1.79 1.79 0 0 0-.74 1.7 2.17 2.17 0 0 0-2.21.21 2.2 2.2 0 0 0-.77 2.31M234.84 74.65a1.82 1.82 0 0 0 2.33.52c.571-.354.893-1 .83-1.67a2.13 2.13 0 0 0 3-2.42M231.62 84.83h2.09v33.68h-2.09z",
    fill: "#fff",
    stroke: "#12186d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.33
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.27 84.21a1.81 1.81 0 0 0 1.82 1.54 1.78 1.78 0 0 0 1.48-1.12 2.13 2.13 0 0 0 2 .9 2.15 2.15 0 0 0 1.8-1.62",
    fill: "#fff",
    stroke: "#12186d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.33
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.59 92a7.42 7.42 0 0 0 6.2-.93 7.24 7.24 0 0 0 2.88-4.59 5.26 5.26 0 0 0 2.07-9.58 7.27 7.27 0 0 0 .8-7.79 6.51 6.51 0 0 0-3.2-2.73 7 7 0 0 0-.87-6 6.1 6.1 0 0 0-2.3-1.81c.78-2.68-.24-5.14-1.94-5.85a3.77 3.77 0 0 0-2.88.18 2.32 2.32 0 0 0-4.43.57 4.21 4.21 0 0 0-3.32 1.92 3.9 3.9 0 0 0-.43 2.58 5.48 5.48 0 0 0-3.75 4.16 5.05 5.05 0 0 0 .51 3 5.34 5.34 0 0 0-2.93 3.23 5.51 5.51 0 0 0 .92 4.78 6.27 6.27 0 0 0-2.67 6.14 6.16 6.16 0 0 0 2.61 3.86 4.46 4.46 0 0 0 4.95 6.72 5.86 5.86 0 0 0 4.18 2.9 5.53 5.53 0 0 0 3.6-.76z",
    fill: "#55f99f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.55 124.34c-3.16-8.34 1.45-13.26 1.45-13.26-7.2 3.63-6.6 13.26-6.6 13.26z",
    fill: "#fff",
    stroke: "#12186d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.66
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.35 124.36c-2.25-5.92 1-9.44 1-9.44-5.12 2.59-4.7 9.44-4.7 9.44z",
    fill: "#fff",
    stroke: "#12186d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.66
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.86 124.32c-1.39-3.64.63-5.8.63-5.8-3.15 1.58-2.89 5.8-2.89 5.8zM219.51 121a2.2 2.2 0 0 0-1.22-2.08.61.61 0 0 0 0-.14 2.11 2.11 0 0 0-1.94-2.26 2 2 0 0 0-.36 0 2 2 0 0 0-.86-.58 2 2 0 0 0-1.74-1.21 2 2 0 0 0-1.66.83 1.79 1.79 0 0 0-.77-.2 1.91 1.91 0 0 0-1.3.45 1.79 1.79 0 0 0-.73-.18 2.08 2.08 0 0 0-2.08 1.85 2.17 2.17 0 0 0-1.53 2c-.02.442.091.88.32 1.26a2.27 2.27 0 0 0-.41 1.24 2.1 2.1 0 0 0 1.94 2.25h.12l10.06.05a2.12 2.12 0 0 0 2.11-2.11 2.56 2.56 0 0 0-.07-.62 2.12 2.12 0 0 0 .12-.55z",
    fill: "#fff",
    stroke: "#12186d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.66
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.79 121.17a1.21 1.21 0 0 0-.22-1 1.08 1.08 0 0 0-.59-1 1 1 0 0 0-.86 0h-.09a1.11 1.11 0 0 0-1.31.37M210.29 121a.94.94 0 0 0-.7-.47.82.82 0 0 0-.89-.24.81.81 0 0 0-.48.48h-.07a.87.87 0 0 0-.53.93M217.26 124.34a16.78 16.78 0 0 0 8-4.42c3.38-3.34 6.09-8.84 4.88-10.4-.94-1.21-4 .24-4.43.45-6.24 3-8.09 12.21-8.47 14.37",
    fill: "#fff",
    stroke: "#12186d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.66
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.26 124.34a17.66 17.66 0 0 1 4-5.2 15.35 15.35 0 0 1 2.75-2",
    fill: "#fff",
    stroke: "#12186d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.66
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.7 119a42.2 42.2 0 0 0 .92-8.79c-.07-3.05-.69-9.14-2.12-9.25s-3.47 5.37-3.76 10.55c-.37 6.72 2.27 13.08 3.52 12.86.53-.12.83-1.88 1.44-5.37z",
    fill: "#fff",
    stroke: "#12186d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.66
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.26 124.34a22.94 22.94 0 0 1-1-5 23.28 23.28 0 0 1 .27-5.94M216.86 124.34a7.31 7.31 0 0 1-3.47-1.91c-1.46-1.45-2.63-3.82-2.1-4.49s1.73.1 1.91.19c2.69 1.27 3.49 5.27 3.66 6.21",
    fill: "#fff",
    stroke: "#12186d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.66
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.86 124.34a7.71 7.71 0 0 0-1.71-2.25 6.87 6.87 0 0 0-1.19-.85",
    fill: "#fff",
    stroke: "#12186d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.66
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.24 122a18.28 18.28 0 0 1-.4-3.8c0-1.32.3-4 .91-4s1.5 2.32 1.63 4.56c.16 2.9-1 5.65-1.52 5.56-.23-.02-.36-.78-.62-2.32z",
    fill: "#fff",
    stroke: "#12186d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.66
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.86 124.34a10.09 10.09 0 0 0 .32-4.74M255.27 85.33a13.12 13.12 0 0 1-6.27-3.48c-2.66-2.63-4.8-7-3.84-8.19.74-1 3.15.19 3.49.35 4.91 2.33 6.37 9.62 6.67 11.32",
    fill: "#fff",
    stroke: "#12186d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.66
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.27 85.33a13.88 13.88 0 0 0-3.12-4.09 12 12 0 0 0-2.15-1.55",
    fill: "#fff",
    stroke: "#12186d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.66
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.14 81.1a33.08 33.08 0 0 1-.73-6.92c.06-2.41.55-7.2 1.67-7.29s2.73 4.23 3 8.32c.29 5.28-1.79 10.29-2.77 10.12-.46-.07-.7-1.46-1.17-4.23z",
    fill: "#fff",
    stroke: "#12186d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.66
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.27 85.33a17.51 17.51 0 0 0 .79-4 18.37 18.37 0 0 0-.21-4.67M255.59 85.33a5.68 5.68 0 0 0 2.73-1.5c1.14-1.14 2.07-3 1.65-3.54s-1.36.08-1.5.15c-2.12 1-2.75 4.15-2.88 4.89",
    fill: "#fff",
    stroke: "#12186d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.66
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.59 85.33a6 6 0 0 1 1.34-1.77 5.36 5.36 0 0 1 .94-.67",
    fill: "#fff",
    stroke: "#12186d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.66
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.08 83.5a14.89 14.89 0 0 0 .31-3c0-1-.24-3.11-.72-3.15s-1.18 1.83-1.28 3.6c-.13 2.28.77 4.44 1.2 4.37.18-.02.28-.62.49-1.82z",
    fill: "#fff",
    stroke: "#12186d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.66
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.59 85.33a7.58 7.58 0 0 1-.35-1.72 8.7 8.7 0 0 1 .09-2",
    fill: "#fff",
    stroke: "#12186d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.66
  }), /*#__PURE__*/React.createElement("path", {
    d: "m240.52 84.79-12.39 37.42h-40.91v3.7h117.03V84.79z",
    fill: "#12186d",
    stroke: "#12186d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.33
  }), /*#__PURE__*/React.createElement("path", {
    d: "m244.88 84.79-12.39 37.42h-40.92v3.7h174.8V84.79z",
    fill: "#fff",
    stroke: "#12186d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.33
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.69 126.09H235.1L245.76 93a6.13 6.13 0 0 1 5.84-4.25h102.12z",
    fill: "#55f99f"
  }))), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M257.91 83.3H370.9v3.71H257.91z",
    fill: "#fff",
    fillRule: "nonzero",
    stroke: "#12186d",
    strokeWidth: 1.33
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M252.12 83.3h108.46v3.71H252.12z",
    fill: "#fff",
    fillRule: "nonzero",
    stroke: "#12186d",
    strokeWidth: 1.33
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "m354.46 84.79-12.39 37.42h-40.91v3.7H405.12V84.79z",
    fill: "#12186d",
    fillRule: "nonzero",
    stroke: "#12186d",
    strokeWidth: 1.33
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "m358.82 84.79-12.39 37.42h-40.91v3.7H409.48V84.79z",
    fill: "#fff",
    fillRule: "nonzero",
    stroke: "#12186d",
    strokeWidth: 1.33
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M373 105.92h2.75c11.046 0 20 8.954 20 20H353c0-11.046 8.954-20 20-20zM383 73.1a14.12 14.12 0 0 0-13.91 11.69h27.83A14.12 14.12 0 0 0 383 73.1zM370.91 82.95h8.44",
    fill: "#fff",
    fillRule: "nonzero",
    stroke: "#12186d",
    strokeWidth: 0.66
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M370.91 81.67h4.61",
    fill: "#fff",
    fillRule: "nonzero",
    stroke: "#12186d"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 0.66
  }, /*#__PURE__*/React.createElement("path", {
    d: "M363.65 112.65h1.7M363.65 111.37h4.61M412.53 77.56a4.74 4.74 0 0 0-2.63-4.49v-.32a4.55 4.55 0 0 0-4.21-4.86 4 4 0 0 0-.78 0 4.29 4.29 0 0 0-1.85-1.26 4.22 4.22 0 0 0-7.34-.82 4 4 0 0 0-1.66-.42 4.14 4.14 0 0 0-2.81 1 4.27 4.27 0 0 0-1.59-.38 4.51 4.51 0 0 0-4.5 4 4.69 4.69 0 0 0-3.3 4.4 4.9 4.9 0 0 0 .69 2.73 5 5 0 0 0-.89 2.67 4.56 4.56 0 0 0 4.21 4.87h.24l21.75.1a4.56 4.56 0 0 0 4.55-4.55 5 5 0 0 0-.13-1.35 5.21 5.21 0 0 0 .25-1.32z",
    fill: "#fff",
    fillRule: "nonzero",
    stroke: "#12186d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.65 77.89a2.61 2.61 0 0 0-.49-2.26 2.31 2.31 0 0 0-1.27-2.21 2.2 2.2 0 0 0-1.86 0l-.19-.11a2.4 2.4 0 0 0-2.83.81M392.61 77.4a2.07 2.07 0 0 0-1.52-1 1.82 1.82 0 0 0-1.93-.53 1.69 1.69 0 0 0-1 1L388 77a1.89 1.89 0 0 0-1.14 2M351.4 125.91a16.75 16.75 0 0 1-8-4.42c-3.37-3.34-6.09-8.84-4.87-10.4.94-1.2 4 .24 4.43.45 6.23 2.95 8.08 12.21 8.47 14.37",
    fill: "#fff",
    fillRule: "nonzero",
    stroke: "#12186d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.4 125.91a17.54 17.54 0 0 0-4-5.2 15.31 15.31 0 0 0-2.74-2",
    fill: "#fff",
    fillRule: "nonzero",
    stroke: "#12186d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350 120.54a42.25 42.25 0 0 1-.93-8.79c.08-3 .7-9.14 2.13-9.25s3.47 5.37 3.75 10.55c.38 6.72-2.27 13.08-3.51 12.86-.57-.09-.87-1.85-1.44-5.37z",
    fill: "#fff",
    fillRule: "nonzero",
    stroke: "#12186d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.4 125.91a22.43 22.43 0 0 0 1-5 23.81 23.81 0 0 0-.26-5.94M351.8 125.91a7.29 7.29 0 0 0 3.46-1.91c1.46-1.45 2.63-3.82 2.11-4.49s-1.73.1-1.91.19c-2.7 1.27-3.5 5.27-3.66 6.21",
    fill: "#fff",
    fillRule: "nonzero",
    stroke: "#12186d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.8 125.91a7.53 7.53 0 0 1 1.71-2.25 7.24 7.24 0 0 1 1.18-.85",
    fill: "#fff",
    fillRule: "nonzero",
    stroke: "#12186d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.42 123.59c.266-1.25.4-2.523.4-3.8 0-1.32-.3-4-.92-4s-1.5 2.32-1.62 4.56c-.16 2.9 1 5.65 1.52 5.56.2-.04.36-.8.62-2.32z",
    fill: "#fff",
    fillRule: "nonzero",
    stroke: "#12186d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.8 125.91a9.89 9.89 0 0 1-.44-2.18 10.37 10.37 0 0 1 .12-2.56M365.66 128.83c-1.38-3.64.63-5.8.63-5.8-3.15 1.59-2.89 5.8-2.89 5.8z",
    fill: "#fff",
    fillRule: "nonzero",
    stroke: "#12186d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.16 128.88c-2.25-5.93 1-9.44 1-9.44-5.13 2.58-4.71 9.44-4.71 9.44z",
    fill: "#fff",
    fillRule: "nonzero",
    stroke: "#12186d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.36 125.91c-3.16-8.32 1.45-13.26 1.45-13.26-7.2 3.63-6.61 13.26-6.61 13.26zM381.31 125.54a2.17 2.17 0 0 0-1.21-2.08v-.15a2.11 2.11 0 0 0-1.95-2.25 2.17 2.17 0 0 0-.36 0 2.08 2.08 0 0 0-.85-.58 2 2 0 0 0-1.74-1.2 2 2 0 0 0-1.66.82 1.94 1.94 0 0 0-2.07.25 2.05 2.05 0 0 0-.74-.17 2.08 2.08 0 0 0-2.08 1.85 2.17 2.17 0 0 0-1.53 2 2.36 2.36 0 0 0 .32 1.27 2.32 2.32 0 0 0-.41 1.23 2.11 2.11 0 0 0 1.95 2.25h10.18a2.1 2.1 0 0 0 2.1-2.1 2.18 2.18 0 0 0-.06-.63 2.05 2.05 0 0 0 .11-.51z",
    fill: "#fff",
    fillRule: "nonzero",
    stroke: "#12186d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.59 125.69a1.23 1.23 0 0 0-.22-1 1.08 1.08 0 0 0-.59-1 1 1 0 0 0-.86 0h-.09a1.12 1.12 0 0 0-1.31.38M372.1 125.46a1 1 0 0 0-.7-.46.86.86 0 0 0-.9-.25.79.79 0 0 0-.47.49h-.08a.88.88 0 0 0-.53.93M395.71 125.54a2.18 2.18 0 0 0-1.22-2.08.76.76 0 0 0 0-.15 2.1 2.1 0 0 0-1.94-2.25 2.23 2.23 0 0 0-.37 0 2.08 2.08 0 0 0-.85-.58 2 2 0 0 0-1.74-1.2 2 2 0 0 0-1.66.82 1.94 1.94 0 0 0-2.07.25 2 2 0 0 0-.74-.17 2.09 2.09 0 0 0-2.08 1.85 2.16 2.16 0 0 0-1.52 2c-.02.446.09.887.32 1.27a2.16 2.16 0 0 0-.41 1.23 2.09 2.09 0 0 0 1.94 2.25h10.18a2.1 2.1 0 0 0 2.1-2.1 2.18 2.18 0 0 0-.06-.63 2.44 2.44 0 0 0 .12-.51z",
    fill: "#fff",
    fillRule: "nonzero",
    stroke: "#12186d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393 125.69a1.2 1.2 0 0 0-.23-1 1.07 1.07 0 0 0-.58-1 1 1 0 0 0-.86 0h-.09a1.12 1.12 0 0 0-1.31.38M386.49 125.46a1 1 0 0 0-.7-.46.85.85 0 0 0-.89-.25.8.8 0 0 0-.48.49h-.07a.88.88 0 0 0-.53.93M379.06 125.91a16.75 16.75 0 0 0 8-4.42c3.37-3.34 6.09-8.84 4.87-10.4-.94-1.2-4 .24-4.43.45-6.23 2.95-8.08 12.21-8.47 14.37",
    fill: "#fff",
    fillRule: "nonzero",
    stroke: "#12186d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.06 125.91a17.54 17.54 0 0 1 4-5.2 15.31 15.31 0 0 1 2.74-2",
    fill: "#fff",
    fillRule: "nonzero",
    stroke: "#12186d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.5 120.54a42.25 42.25 0 0 0 .93-8.79c-.08-3-.7-9.14-2.13-9.25s-3.47 5.37-3.75 10.55c-.38 6.72 2.27 13.08 3.51 12.86.53-.09.83-1.85 1.44-5.37z",
    fill: "#fff",
    fillRule: "nonzero",
    stroke: "#12186d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.06 125.91a22.43 22.43 0 0 1-1-5 23.81 23.81 0 0 1 .26-5.94M378.66 128.85a7.2 7.2 0 0 1-3.46-1.91c-1.46-1.44-2.63-3.82-2.11-4.49.41-.52 1.73.11 1.91.19 2.7 1.28 3.5 5.28 3.66 6.21",
    fill: "#fff",
    fillRule: "nonzero",
    stroke: "#12186d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.66 128.85a7.51 7.51 0 0 0-1.71-2.24 6.68 6.68 0 0 0-1.18-.85M378 123.59a18.21 18.21 0 0 1-.4-3.8c0-1.32.3-4 .92-4s1.5 2.32 1.62 4.56c.16 2.9-1 5.65-1.52 5.56-.19-.04-.32-.8-.62-2.32z",
    fill: "#fff",
    fillRule: "nonzero",
    stroke: "#12186d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.66 125.91a9.89 9.89 0 0 0 .44-2.18 10.37 10.37 0 0 0-.12-2.56",
    fill: "#fff",
    fillRule: "nonzero",
    stroke: "#12186d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.9 121.63 250.8 94a5.11 5.11 0 0 1 4.87-3.54M251 121.63 259.93 94a5.12 5.12 0 0 1 4.87-3.54M260.16 121.63l8.9-27.63a5.12 5.12 0 0 1 4.87-3.54M269.29 121.63l8.9-27.63a5.12 5.12 0 0 1 4.87-3.54M278.42 121.63l8.9-27.63a5.12 5.12 0 0 1 4.87-3.54M287.56 121.63 296.45 94a5.12 5.12 0 0 1 4.87-3.54M296.69 121.63 305.58 94a5.12 5.12 0 0 1 4.87-3.54M305.82 121.63l8.9-27.63a5.1 5.1 0 0 1 4.86-3.54M315 121.63 323.85 94a5.11 5.11 0 0 1 4.87-3.54M324.08 121.63 333 94a5.12 5.12 0 0 1 4.87-3.54M333.21 121.63l8.9-27.63a5.12 5.12 0 0 1 4.89-3.54",
    stroke: "#fff"
  }))), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M299 110.07c.05 0 .19-.08.26-.16a.79.79 0 0 0 .12-.16c.29-.58.33-.69.29-.81a.23.23 0 0 0-.1-.13c-.09 0-.23.08-.35.27-.32.76-.33.92-.22.99zM303 111.64c.3-.061.605-.081.91-.06.08 0 .64 0 .65.16s-.17.17-1 .35c0 0 .2.35.08.48s-.46 0-.6-.12a1.41 1.41 0 0 1-.5-.53z",
    fill: "#12186d",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M297.47 109.77a.19.19 0 0 1 .08-.26 2.84 2.84 0 0 1 1.09-.22c.476 0 .95.077 1.4.23a7.68 7.68 0 0 1 3 2.12.44.44 0 0 1-.14.43 3 3 0 0 0-.51-.07 8.39 8.39 0 0 1-2.47-.45 4 4 0 0 1-2.12-1.29 4.22 4.22 0 0 1-.33-.49z",
    style: {
      stroke: "#12186d",
      strokeWidth: 0.74,
      fill: "#fff",
      fillRule: "nonzero",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M299.69 109.54c.256.16.527.294.81.4.51.25.88.48 1.13.63a13 13 0 0 1 1.12.77l-.2-.34a1.33 1.33 0 0 0-.25-.88 1.75 1.75 0 0 0-1.38-.53h-.34c-.58.04-.87-.09-.89-.05zM299 110.85c.05 0 .21 0 .3.08a.86.86 0 0 1 .16.13c.44.48.51.56.5.69a.17.17 0 0 1-.06.15c-.08.06-.24 0-.42-.16-.48-.65-.48-.84-.48-.89z",
    fill: "#12186d",
    fillRule: "nonzero"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 298.485,
    cy: 110.084,
    fill: "#12186d",
    fillRule: "nonzero",
    transform: "rotate(-37.79 298.485 110.084)",
    r: 1
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M245.75 124.63c-.06 0-.2-.09-.27-.16a1.11 1.11 0 0 1-.11-.17c-.3-.58-.34-.68-.3-.8s0-.11.1-.13.24.07.36.27c.27.76.27.96.22.99zM241.65 126.2a3 3 0 0 0-.91-.06c-.08 0-.64 0-.64.15s.17.17 1 .36c0 0-.2.35-.09.47s.47 0 .61-.12c.21-.123.38-.304.49-.52z",
    fill: "#12186d",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M247.22 124.32a.19.19 0 0 0-.08-.26 3.1 3.1 0 0 0-1.09-.21 4.11 4.11 0 0 0-1.39.22 7.74 7.74 0 0 0-3 2.13.47.47 0 0 0 0 .2.41.41 0 0 0 .13.22 1.79 1.79 0 0 1 .51-.07 8.46 8.46 0 0 0 2.47-.45 4.07 4.07 0 0 0 2.11-1.29 3 3 0 0 0 .34-.49z",
    style: {
      stroke: "#12186d",
      strokeWidth: 0.33,
      fill: "#fff",
      fillRule: "nonzero",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M245 124.1a5.55 5.55 0 0 1-.8.4c-.52.25-.89.48-1.13.62s-.68.44-1.12.77l.2-.34a1.32 1.32 0 0 1 .24-.88 1.71 1.71 0 0 1 1.39-.52h.33c.54.03.89-.09.89-.05zM245.68 125.41s-.2 0-.29.08a.92.92 0 0 0-.16.12c-.45.48-.51.57-.51.7 0 .056.02.11.06.15.08.05.25 0 .42-.16.47-.66.53-.85.48-.89z",
    fill: "#12186d",
    fillRule: "nonzero"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 246.202,
    cy: 124.653,
    fill: "#12186d",
    fillRule: "nonzero",
    transform: "rotate(-52.21 246.202 124.653)",
    r: 1
  })), /*#__PURE__*/React.createElement("path", {
    d: "M14.69 127c7 102.23 92.12 183 196.12 183s189.13-80.75 196.13-183z",
    style: {
      stroke: "#12186d",
      strokeWidth: 2,
      fill: "#fff",
      fillRule: "nonzero",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M131.7 130.08v14a3.11 3.11 0 0 1-.25 1.2l-3.91 9.12a3 3 0 0 1-.76 1.06l-5.86 5.27a3.06 3.06 0 0 0-1 2.27v13.5c0 .406.081.807.24 1.18l6.84 16.44a3 3 0 0 0 .82 1.14l30.11 25.9a3.07 3.07 0 0 1 1.06 2.2l2.13 55.26c.02.551.19 1.087.49 1.55l8.64 13.3a3.07 3.07 0 0 0 1.25 1.09l12.59 6c.408.198.856.3 1.31.3h1.42a3.06 3.06 0 0 0 3.05-3.05 3.06 3.06 0 0 0-1-2.28l-4.49-4a3.07 3.07 0 0 1-1-2.47l.58-9.25a3.06 3.06 0 0 1 .76-1.84L189 273a3.05 3.05 0 0 1 2.06-1l7.81-.56a3 3 0 0 0 2.13-1.04l17.12-19.86a3.18 3.18 0 0 1 1.11-.81l3.54-1.51a3 3 0 0 0 1.47-1.34l6.87-12.48a3 3 0 0 1 2.22-1.55l11.84-1.78a3 3 0 0 0 2.14-1.39l2-3.27a3 3 0 0 1 2.59-1.41h1a3.07 3.07 0 0 0 3-2.35l5.85-24.72a3 3 0 0 1 .91-1.55l7.15-6.56a3.051 3.051 0 0 0 1-2.25v-6.9a3 3 0 0 0-1.91-2.83l-8.78-3.51a3 3 0 0 0-.73-.19L239 171.4a3.06 3.06 0 0 1-2.08-1.25l-2-2.88a3.06 3.06 0 0 0-2.34-1.27l-11.66-.56a3 3 0 0 1-2.83-2.38l-2.31-10.39a3.13 3.13 0 0 0-.48-1.09l-3.9-5.57a3.05 3.05 0 0 0-2.49-1.3h-14.76a3.05 3.05 0 0 1-2.86-2l-3.29-8.65a3.05 3.05 0 0 0-1.5-1.66l-10.17-5a3.006 3.006 0 0 0-1.33-.4h-40.25a3.002 3.002 0 0 0-3.05 3.08z",
    stroke: "#12186d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M141.27 130.08v14a3.11 3.11 0 0 1-.25 1.2l-3.91 9.12a3 3 0 0 1-.76 1.06l-5.86 5.27a3.05 3.05 0 0 0-1 2.27v13.5c0 .404.079.805.23 1.18l6.85 16.44a3 3 0 0 0 .83 1.14l30.1 25.9a3 3 0 0 1 1.06 2.2l2.13 55.26c.02.551.19 1.087.49 1.55l8.64 13.3a3.07 3.07 0 0 0 1.25 1.09l12.59 6c.408.198.856.3 1.31.3h1.42a3.06 3.06 0 0 0 3.05-3.05 3 3 0 0 0-1-2.28l-4.49-4a3.1 3.1 0 0 1-1-2.47l.58-9.25a3 3 0 0 1 .77-1.84l4.36-4.91a3.05 3.05 0 0 1 2.07-1l7.8-.56a3 3 0 0 0 2.09-1.05l17.12-19.86a3.28 3.28 0 0 1 1.11-.81l3.54-1.51a3.06 3.06 0 0 0 1.48-1.34l6.86-12.48a3 3 0 0 1 2.22-1.55l11.85-1.78a3 3 0 0 0 2.13-1.39l2-3.27a3.06 3.06 0 0 1 2.59-1.43h1a3.07 3.07 0 0 0 3-2.35l5.85-24.72a3 3 0 0 1 .91-1.55l7.16-6.56a3.05 3.05 0 0 0 1-2.25v-6.9a3 3 0 0 0-1.92-2.83l-8.78-3.51a3 3 0 0 0-.73-.19l-20.4-2.72a3.06 3.06 0 0 1-2.08-1.25l-2.05-2.88a3.06 3.06 0 0 0-2.38-1.32l-11.66-.56a3 3 0 0 1-2.83-2.38l-2.31-10.39a3.13 3.13 0 0 0-.48-1.09l-3.89-5.58a3.07 3.07 0 0 0-2.5-1.3h-14.71a3 3 0 0 1-2.85-2l-3.26-8.68a3.05 3.05 0 0 0-1.5-1.66l-10.17-5a3.004 3.004 0 0 0-1.35-.32h-40.27a3.05 3.05 0 0 0-3.05 3.04z",
    fill: "#55f99f",
    fillRule: "nonzero"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "m386.38 127 .05 11 1.1 2a24.94 24.94 0 0 1 3 10l1 11.44a72 72 0 0 1-.72 18l-1.46 8.74-2 3.17A43.71 43.71 0 0 0 381 210l-.24 2.32s22.63-38.93 26.32-85.32z",
    stroke: "#12186d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "m392.32 127.78.05 11 1.1 2a25 25 0 0 1 3 9.95l1 11.45a72 72 0 0 1-.72 18l-1.45 8.73-2 3.18a43.8 43.8 0 0 0-6.42 18.7l-.24 2.32s22.64-38.92 26.32-85.31z",
    fill: "#55f99f",
    fillRule: "nonzero"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M329.29 169c-4.27 8-8 0-8 0-4.27 8-8 0-8 0h-.53c-4.27 8-8 0-8 0M85.56 205.83c-4.27 8-8 0-8 0-4.27 8-8 0-8 0H69c-4.27 8-8 0-8 0",
    stroke: "#12186d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.66
  })), /*#__PURE__*/React.createElement("path", {
    d: "M323.18 128.66a.86.86 0 0 0-.18.14 1.47 1.47 0 0 0-1.28-.37v-.08a2.06 2.06 0 0 0-2.65-.84 4.17 4.17 0 0 0-.39-.93 3.8 3.8 0 0 0-6.79.42 3.86 3.86 0 0 0-2.89-1.07 4.88 4.88 0 0 0-6.47-1.47l-.19.12a4.89 4.89 0 0 0-3.53-.3c0-.11-.11-.21-.17-.32a4.88 4.88 0 0 0-5.39-2.29 7.75 7.75 0 0 0-11.33 1.2 6.27 6.27 0 0 0-9.49.48 4.88 4.88 0 0 0-6-.85 4.8 4.8 0 0 0-2.06 2.36 4.89 4.89 0 0 0-6.14-1 5.24 5.24 0 0 0-.66.47 3.81 3.81 0 0 0-3.91 2.4 2.07 2.07 0 0 0-2.12 0 2.17 2.17 0 0 0-.83.9 1.48 1.48 0 1 0-.33 2.3 1.64 1.64 0 0 0 .42-.37 2.07 2.07 0 0 0 2.82.75 2.32 2.32 0 0 0 .3-.22 3.83 3.83 0 0 0 3.73 1.84 4.87 4.87 0 0 0 7.54-2 4.88 4.88 0 0 0 6.13 1 5.83 5.83 0 0 0 .7-.49 6.25 6.25 0 0 0 9.6 1.3 7.76 7.76 0 0 0 13.27-.5c.3-.032.599-.088.89-.17a3.3 3.3 0 0 0 .18.32 4.87 4.87 0 0 0 6.66 1.77l.19-.11a4.89 4.89 0 0 0 4.42-.08 3.81 3.81 0 0 0 5.48-1.75 3.83 3.83 0 0 0 4.56.56 3.87 3.87 0 0 0 1.12-1 2.08 2.08 0 0 0 2.55.38l.15-.1a1.48 1.48 0 0 0 2.06-.24 1.25 1.25 0 0 0 1.32 0 1.273 1.273 0 0 0-1.28-2.2z",
    style: {
      stroke: "#12186d",
      strokeWidth: 0.66,
      fill: "#fff",
      fillRule: "nonzero",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 248.03,
    cy: 121.73,
    r: 1,
    style: {
      stroke: "#12186d",
      strokeWidth: 0.66,
      fill: "#fff",
      fillRule: "nonzero",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 316.68,
    cy: 121.57,
    r: 1,
    style: {
      stroke: "#12186d",
      strokeWidth: 0.66,
      fill: "#fff",
      fillRule: "nonzero",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 294.73,
    cy: 135.45,
    r: 1,
    style: {
      stroke: "#12186d",
      strokeWidth: 0.66,
      fill: "#fff",
      fillRule: "nonzero",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 294.41,
    cy: 115.24,
    r: 1,
    style: {
      stroke: "#12186d",
      strokeWidth: 0.66,
      fill: "#fff",
      fillRule: "nonzero",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 312.81,
    cy: 135.3,
    r: 1,
    style: {
      stroke: "#12186d",
      strokeWidth: 0.66,
      fill: "#fff",
      fillRule: "nonzero",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 310.03,
    cy: 120.08,
    r: 2.31,
    style: {
      stroke: "#12186d",
      strokeWidth: 0.66,
      fill: "#fff",
      fillRule: "nonzero",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 277.7,
    cy: 117.55,
    r: 2.31,
    style: {
      stroke: "#12186d",
      strokeWidth: 0.66,
      fill: "#fff",
      fillRule: "nonzero",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 324.17,
    cy: 125.47,
    r: 1,
    style: {
      stroke: "#12186d",
      strokeWidth: 0.66,
      fill: "#fff",
      fillRule: "nonzero",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 268.75,
    cy: 119.87,
    r: 1,
    style: {
      stroke: "#12186d",
      strokeWidth: 0.66,
      fill: "#fff",
      fillRule: "nonzero",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })));
};

export default SvgEarth;